import React, { Fragment } from "react";
import { ContentListItem } from "./ContentListItem/ContentListItem";
import { ContentResultListProps } from "./ContentResultList.types";
import { ResultList } from "../SearchContent.styles";
import { DividerCustom } from "../../../../Post/SearchFallback/ContentListItem/ContentListItem.styles";
import { splitSearchValue } from "@infrastructure/Helpers/StringHelper";

export const ContentResultList = ({
    items,
    onItemClick,
    searchTerms,
}: ContentResultListProps) => {
    const highlightTerms = splitSearchValue(searchTerms);
    const dividerLimit = items.length - 1;

    return (
        <ResultList>
            {items.map((content, index) => (
                <Fragment key={content.contentType + String(content.id)}>
                    <ContentListItem
                        onItemClick={() => onItemClick(content)}
                        content={content}
                        stringsToHighlight={highlightTerms}
                    />
                    {index < dividerLimit && <DividerCustom variant="inset" />}
                </Fragment>
            ))}
        </ResultList>
    );
};
